import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";
import React from "react";

import { ScheduledJobType } from "../../../../enums/ScheduledJobType";
import { ScheduledJob } from "../../../../dtos/scheduledJob";
import { ScheduledJobForm } from "../ScheduledJobForm";

import { useAddScheduledJob } from "./useAdd";


interface Props {
    open: boolean;
    onClose: () => void;
    onJobAdded: (job: ScheduledJob) => void;
    availableJobTypes: ScheduledJobType[];
}

export function AddScheduledJobDialog({ open, onClose, onJobAdded, availableJobTypes }: Props) {
    const { add, loading, jobBase, setJobBase } = useAddScheduledJob(onJobAdded);

    return (
        <Dialog
            fullWidth={true}
            maxWidth="md"
            open={open}
            onClose={onClose}
        >
            <DialogContent>
                <ScheduledJobForm
                    jobBase={jobBase}
                    setJobBase={setJobBase}
                    availableJobTypes={availableJobTypes}
                />
            </DialogContent>

            <DialogActions>
                <Button
                    color="primary"
                    variant="contained"
                    disabled={loading}
                    onClick={add}
                >
                    Add
                </Button>

                <Button
                    color="secondary"
                    variant="contained"
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
}